export const GET_INFOMATION_STATICS = 'GET_INFOMATION_STATICS';// 获取点赞评论统计

export const GET_INFOMATION_POSTS = 'GET_INFOMATION_POSTS';// 获取资讯和帖子管理信息

export const CREATE_INFOMATION_POST = 'CREATE_INFOMATION_POST';// 创建资讯和帖子管理信息

export const UPDATE_INFOMATION_POST = 'UPDATE_INFOMATION_POST';

export const DELETE_INFOMATION_POST = 'DELETE_INFOMATION_POST';
